'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { THUNDERDOME } from 'HubStyleTokens/colors';
import UIToolBar from 'UIComponents/nav/UIToolBar';
import UIToolBarGroup from 'UIComponents/nav/UIToolBarGroup';
import UIButton from 'UIComponents/button/UIButton';
import { useHistory } from 'react-router-dom';
import PracticalExerciseReviewButton from './PracticalExerciseReviewButton';
import PracticalExerciseInstructionsPopover from './PracticalExerciseInstructionsPopover';
import { FormattedMessage, FormattedHTMLMessage } from 'LearningCenterUI/components/I18n';
import { useCallback } from 'react';
import { useSetAutomaticallyGradedPracticalExerciseSubmitted, useSetManuallyGradedPracticalExerciseSubmitted } from '../';
const UIToolbarThunderdome = styled(UIToolBar).withConfig({
  displayName: "PracticalExerciseToolbar__UIToolbarThunderdome",
  componentId: "sc-15gnrnn-0"
})(["background:", " !important;"], THUNDERDOME);
const Title = styled.div.withConfig({
  displayName: "PracticalExerciseToolbar__Title",
  componentId: "sc-15gnrnn-1"
})(["font-size:16px;"]);

const PracticalExerciseToolbar = (_ref) => {
  let {
    parentTo
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["parentTo"]);

  const history = useHistory();
  const [submitGradedContent] = useSetManuallyGradedPracticalExerciseSubmitted();
  const [submitAutomaticallyGradedContent] = useSetAutomaticallyGradedPracticalExerciseSubmitted();
  const {
    contentId,
    exerciseLanguage,
    name,
    isManuallyApproved,
    isGraded
  } = props;
  const onReviewExercise = useCallback(() => {
    if (isManuallyApproved) {
      return submitGradedContent(Number(contentId), exerciseLanguage).then(() => history.push(parentTo));
    } else {
      return submitAutomaticallyGradedContent(Number(contentId)).then(() => history.push(parentTo));
    }
  }, [isManuallyApproved, submitGradedContent, contentId, exerciseLanguage, history, parentTo, submitAutomaticallyGradedContent]);
  return /*#__PURE__*/_jsxs(UIToolbarThunderdome, {
    use: "dark",
    children: [/*#__PURE__*/_jsx(UIToolBarGroup, {
      style: {
        flexGrow: 3,
        flexBasis: 'auto'
      },
      children: /*#__PURE__*/_jsx(Title, {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "learningCenter.practicalExercise.toolbar.title",
          options: {
            exerciseName: name || ''
          }
        })
      })
    }), /*#__PURE__*/_jsxs(UIToolBarGroup, {
      style: {
        justifyContent: 'right'
      },
      children: [/*#__PURE__*/_jsx(PracticalExerciseInstructionsPopover, Object.assign({}, props)), /*#__PURE__*/_jsx(UIButton, {
        onClick: () => history.push(parentTo),
        use: "secondary-ghost",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.toolbar.finishLater"
        })
      }), /*#__PURE__*/_jsx(PracticalExerciseReviewButton, {
        className: "m-right-3",
        graded: isGraded,
        isManual: isManuallyApproved,
        labelI18n: "learningCenter.practicalExercise.toolbar.submitForGrading",
        onConfirm: onReviewExercise,
        use: "tertiary-light"
      })]
    })]
  });
};

PracticalExerciseToolbar.propTypes = {
  contentId: PropTypes.string,
  description: PropTypes.string,
  exerciseLanguage: PropTypes.string,
  isGraded: PropTypes.bool,
  isManuallyApproved: PropTypes.bool,
  name: PropTypes.string,
  nextContentUrl: PropTypes.string,
  parentTo: PropTypes.string.isRequired
};
export default PracticalExerciseToolbar;